// extracted by mini-css-extract-plugin
export default {"container":"case_container__Z4FPn","scrollableContent":"case_scrollableContent__SKBDS"};